import React, { useEffect } from "react";
import useTrustPicker from "../../hooks/useTrustPicker";
import { useTokenFlow } from "../../../Common/hooks";
import { Autocomplete, AutocompleteProps, TextField, TextFieldProps } from "@mui/material";
import { globalConfig } from "../../../Common/configuration/config";
import FormHeader from "../../../Common/components/templates/formHeader";
import PrimaryButton from "../../../Common/components/templates/buttons/primary";

type Option = { id: string; label: string };
type CustomerCodeSelectorProps = Omit<
  AutocompleteProps<Option, undefined, undefined, undefined>,
  "renderInput" | "options"
>;

let selectedTrust: { id: string; };

/**
 * TODO: Build a combobox based on Material UI Autocomplete component.
 *
 * @see https://mui.com/components/autocomplete/
 */

function CustomerCodeSelector(props: CustomerCodeSelectorProps): JSX.Element {
  const { sx, ...other } = props;

  const renderInput = React.useCallback(
    (props: JSX.IntrinsicAttributes & TextFieldProps) => <TextField placeholder="Select a customer..." {...props} />,
    []
  );

  const { trustPicker } = useTrustPicker();

  return (
    <Autocomplete
      sx={{
        margin: "10px", ...sx
      }}
      options={trustPicker.result}
      onChange={(event: any, value: any) => selectedTrust = value}
      renderInput={renderInput}
      {...other}
    />
  );
}

export const continueState = (auth0state: string, trust: string, domain: string) => {
  const temp: any = window;
  temp.location = `https://${domain}/continue?state=${auth0state}&trust=${trust}&scope=${globalConfig.config.Scope}`;
};

const TrustPicker = (props: any) => {
  let params = new URLSearchParams(props.location.search);
  let token = params.get("token");
  let connection = params.get("connection");
  let auth0state = params.get("state");
  localStorage.setItem("auth0state", auth0state || '');

  const { trustPicker, handleReturnCustomerCodes } = useTrustPicker();
  const { tokenFlow, handleStartTokenFlow } = useTokenFlow();
  const config = globalConfig.get();

  useEffect(() => {
    if (token !== null && connection !== null) {
      handleStartTokenFlow(token ?? "");
    }
  }, []);

  useEffect(() => {
    if (tokenFlow.loggedUser.isValid) {
      handleReturnCustomerCodes(token, connection);
    }
  }, [token, connection, tokenFlow.loggedUser.isValid]);

  const handleSubmit = () => {
    if (auth0state) continueState(auth0state, selectedTrust.id, config.Domain);
  };

  return (
    <form className="form" style={{height: "500px"}}>
      <FormHeader title="Provide your trust" />
      {tokenFlow.loggedUser.message !== null ? (
        <div className="error">
          {" "}
          {tokenFlow.loggedUser.message} {" "}
        </div>
      ) : null}
      <div className="content">
        <CustomerCodeSelector />
        <div className="buttons">
          <PrimaryButton
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={!tokenFlow.loggedUser.isValid || trustPicker.result.length <= 1}>
            Continue
          </PrimaryButton>
        </div>
      </div>
    </form>
  );
};

export { TrustPicker, CustomerCodeSelector};